import { useCallback } from "react";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { openIntercomMessenger } from "@/lib/intercom/intercomMessenger";
import { openIntercom } from "@/utils/intercomUtils";
import { useAuth } from "@/hooks/useAuth";

/** Open Fin / Intercom messenger (native + web). */
export function useNativeWebChatPrompt() {
  const { user } = useAuth();
  const { isNative } = useNativePlatform();

  const requestChat = useCallback(() => {
    try {
      openIntercomMessenger(
        user?.email
          ? {
              email: user.email,
              id: user.id ? String(user.id) : undefined,
              name: user.name,
            }
          : undefined,
      );
    } catch {
      openIntercom();
    }
  }, [user?.email, user?.id, user?.name]);

  return {
    promptOpen: false,
    setPromptOpen: () => {},
    requestChat,
    isNative,
  };
}
